<div class="background" style="min-width :1360px">
    <nav class="navbar navbar-light bg-light">
        <a class="navbar-brand" [routerLink]="['/home']">
            <h6 class="Ws-logo">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <span class="navbar-text justify-content-end">
            <ul class="nav menu-container">
                <li [routerLink]="['/admin/gdrive']"
                    [ngClass]="{'nav-item': !showGdriveList,'nav-item-active' : showGdriveList}">
                    {{constants.ADMIN_NAV_ITEM_0}}</li>
                <li [routerLink]="['/admin']"
                    [ngClass]="{'nav-item': !showPendingList,'nav-item-active' : showPendingList}">
                    {{constants.ADMIN_NAV_ITEM_1}}</li>
                <li [routerLink]="['/admin/rejected']"
                    [ngClass]="{'nav-item': !showRejectList,'nav-item-active' : showRejectList}">
                    {{constants.ADMIN_NAV_ITEM_3}}</li>
                <li [routerLink]="['/admin/failed']" [ngClass]="{'nav-item': !showFailedList,'nav-item-active' : showFailedList}">
                    {{constants.ADMIN_NAV_ITEM_5}}</li>
                <li [routerLink]="['/admin/uploaded']"
                    [ngClass]="{'nav-item': !showUploadedList,'nav-item-active' : showUploadedList}">
                    {{constants.ADMIN_NAV_ITEM_4}}</li>
                <li [routerLink]="['/admin/curated']"
                    [ngClass]="{'nav-item': !showCuratedList,'nav-item-active' : showCuratedList}">
                    {{constants.ADMIN_NAV_ITEM_6}}</li>    
                <li class="nav-item"> <a [routerLink]="['/user']">
                        <img class="profile-avatar" src="{{profilePicture}}" />
                    </a></li>
            </ul>

        </span>
    </nav>
    <app-admin-pending *ngIf="this.from === 'admin'"></app-admin-pending>
    <app-admin-rejected *ngIf="this.from === 'admin,rejected'"></app-admin-rejected>
    <app-admin-uploaded *ngIf="this.from === 'admin,uploaded'"></app-admin-uploaded>
    <app-admin-offline *ngIf="this.from === 'admin,uploaded,1'"></app-admin-offline>
    <app-admin-gdrive *ngIf="this.from === 'admin,gdrive'"></app-admin-gdrive>
    <app-admin-failed  *ngIf="this.from === 'admin,failed'"></app-admin-failed>
    <app-admin-curated *ngIf="(this.from === 'admin,curated')||(this.from === 'admin,curated,1')"></app-admin-curated>
</div>